<template>
  <div>
    <page-table :orderCode="orderCode" />
  </div>
</template>
<script>
import PageTable from './components/table'
export default {
  props: { orderCode: { type: String, default: '' } },
  components: { PageTable },
}
</script>
